<!-- 
  新建 客户寄送信息
  prop: 
    item: 绑定对象
    form: form表单数据对象
 -->

<template>
  <div class="customer">
    <!-- 地址 -->
    <v-address
      @change="addressSave"
      v-if="item.attr === 'address'"
      module="invoice"
      :attrValue="form.address">
    </v-address>
  </div>
</template>

<script>
import Vue from 'vue'
import vAddress from '../address'

export default {
  props: ['item', 'form'],
  methods: {
    addressSave (arr) {
      Vue.set(this.form, 'address', arr)
    }
  },
  components: {
    vAddress
  }
}
</script>


// WEBPACK FOOTER //
// index.vue?8bfe3f1c